import { keys } from 'lodash';
import * as types from './types';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import {
  api,
  chunkedMultiIdApiCall,
  multiIdApiActionDispatcher,
  multiIdRequestCacheCheck,
  signalRWrappedApiCall
} from './api';
import { metricsReducer } from '../reducers';
import { httpRequestHeader } from '../helpers';
import { paramsMetricsPayloadsHandler } from './signalRHub/hubPayloadsHandler';


const fetchMetricsDispatcher = multiIdApiActionDispatcher({
  actionTypes: types.metricsActionTypes,
  emptyResult: () => { return {}; }
});

export const fetchMetricsByJobIds =
  (jobIds, requestHeader = httpRequestHeader.REQUEST_HEADER) =>
    signalRWrappedApiCall(
      chunkedMultiIdApiCall(
        jobIds,
        1000,
        fetchMetricsDispatcher,
        api.metrics.fetchByJobIds,
        (state, ids) => multiIdRequestCacheCheck(state.metrics.request, ids),
        requestHeader
      ),
      fetchMetricsDispatcher([]),
      signalRHubManager,
      subscriptionTypes.metrics,
      state => keys(metricsReducer.metricsByJobIds(state)),
      (args, payloads) => paramsMetricsPayloadsHandler(args, payloads, 'job_id')
    );




// WEBPACK FOOTER //
// src/actions/metrics.js